import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=0c4f3ae0&"
import script from "./menuItem.vue?vue&type=script&lang=js&"
export * from "./menuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports